
import axios from 'axios'

export default {

    getClassIndex(){
        return axios.get('/dev-class-index')
            .then(response => {
                return response.data
            })
    },

    getBatch(){
        return axios.get('/class-batch')
            .then(response => {
                return response.data
            })
    },
    getBatchDataSource(params){
        return axios.get('/class-batch/datasource', {params})
            .then(response => {
                return response.data
            })
    },
    getBatchbyID(id){
        return axios.get('/class-batch/' + id)
            .then(response => {
                return response.data
            })
    },    
    createBatch(formdata){
        return axios.post('/class-batch', formdata)
            .then(response => {
                return response.data
            })
    },
    updateBatch(id,formdata){
        return axios.post('/class-batch/' + id, formdata)
            .then(response => {
                return response.data
            })
    },
    deactivateBatch(id){
        return axios.put('/class-batch/' + id + '/deactivate')
            .then(response => {
                return response.data
            })
    },
    reactivateBatch(id){
        return axios.put('/class-batch/' + id + '/reactivate')
            .then(response => {
                return response.data
            })
    },
    destroyBatch(id){
        return axios.delete('/class-batch/' + id + '/delete')
            .then(response => {
                return response.data
            })
    }, 
    assign_class(id,formdata){
        return axios.post('/class-batch/' + id + '/assign-class-template' ,formdata)
            .then(response => {
                return response.data
            })
    },
    updateImage(id,formdata){
        return axios.post('/class-batch/' + id + '/image' ,formdata)
            .then(response => {
                return response.data
            })
    },
    getTemplate() {
        return axios.get("/class-template").then((response) => {
           return response.data;
        });
     },
     getTemplateDataSource(params) {
        return axios
           .get("/class-template/datasource", { params })
           .then((response) => {
              return response.data;
           });
     },
     getTemplatebyID(id) {
        return axios.get("/class-template/" + id).then((response) => {
           return response.data;
        });
     },
     createTemplate(formdata) {
        return axios.post("/class-template", formdata).then((response) => {
           return response.data;
        });
     },
     updateTemplate(id, formdata) {
        return axios.post("/class-template/" + id, formdata).then((response) => {
           return response.data;
        });
     },
     deactivateTemplate(id) {
        return axios
           .put("/class-template/" + id + "/deactivate")
           .then((response) => {
              return response.data;
           });
     },
     reactivateTemplate(id) {
        return axios
           .put("/class-template/" + id + "/reactivate")
           .then((response) => {
              return response.data;
           });
     },
     destroyTemplate(id) {
        return axios
           .delete("/class-template/" + id + "/delete")
           .then((response) => {
              return response.data;
           });
     },

    getDevPeoples(params) {
        return axios.get('/dev/peoples', { params })
            .then(response => {
                return response.data
            })
    },

    getDevUsersWithoutPeople(params) {
        return axios.get('/dev/users-without-people', { params })
            .then(response => {
                return response.data
            })
    },

    getDevPeopleDetail(peopleUuid, params) {
        return axios.get('/dev/peoples/' + peopleUuid, { params })
            .then(response => {
                return response.data
            })
    },

    getDevPeopleLogs(peopleUuid, params) {
        return axios.get('/dev/peoples/' + peopleUuid + '/logs/people-logs', { params })
            .then(response => {
                return response.data
            })
    },

    getDevPeopleActivity(peopleUuid, params) {
        return axios.get('/dev/peoples/' + peopleUuid + '/logs/people-activity', { params })
            .then(response => {
                return response.data
            })
    },

    getDevPeopleStatusMovement(peopleUuid, params) {
        return axios.get('/dev/peoples/' + peopleUuid + '/logs/people-status-movement', { params })
            .then(response => {
                return response.data
            })
    },

    getDevPeopleLogsSync(params) {
        return axios.get('/dev/people-logs-sync', { params })
            .then(response => {
                return response.data
            })
    },

    getFilesManagerCategories() {
        return axios.get('/dev/files-manager/categories')
            .then(response => {
                return response.data
            })
    },

    getFilesManagerFiles(category, params) {
        return axios.get('/dev/files-manager/categories/' + category + '/files', { params })
            .then(response => {
                return response.data
            })
    },

    getFilesManagerFileDetail(params) {
        return axios.get('/dev/files-manager/files/detail', { params })
            .then(response => {
                return response.data
            })
    },

    compressFilesManagerPreview(payload) {
        return axios.post('/dev/files-manager/compress-preview', payload)
            .then(response => {
                return response.data
            })
    },

    compressFilesManagerApply(payload) {
        return axios.post('/dev/files-manager/compress-apply', payload)
            .then(response => {
                return response.data
            })
    },
}